





















import Vue from 'vue'
import FilterDrawer from '@/components/FilterDrawer.vue'
import TextButton from './TextButton.vue'
export default Vue.extend({
  components: {
    appFilterDrawer: FilterDrawer,
    TextButton,
  },
  data() {
    return {
      filterModel: false,
    }
  },
  computed: {
    isDark(): boolean {
      return this.$vuetify.theme.dark
    },
  },
})
